import { render } from "./CustomerServiceWeek.vue?vue&type=template&id=7ac97b80&scoped=true"
import script from "./CustomerServiceWeek.vue?vue&type=script&lang=js"
export * from "./CustomerServiceWeek.vue?vue&type=script&lang=js"

import "./CustomerServiceWeek.vue?vue&type=style&index=0&id=7ac97b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac97b80"]])

export default __exports__